import { useMutation } from 'react-query';

import {
  MarketingModalCreateOrUpdateRequest,
  createOrUpdateExternalMarketingModal,
} from '@utils/backend-api/marketingModals';

export default function useCreateOrUpdateExternalMarketingModal() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (props: MarketingModalCreateOrUpdateRequest) => createOrUpdateExternalMarketingModal(props)
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
